import { Component, OnInit, EventEmitter, Input, Output, DoCheck } from '@angular/core';
import { SharedService } from '../../shared/shared.service';
import { environment } from '../../../environments/environment';
import { Router } from '@angular/router';
import { ToastsManager } from 'ng2-toastr/ng2-toastr';
import { Subscription } from 'rxjs';
import { Logger } from 'angular2-logger/core';
import { NgxSpinnerService } from 'ngx-spinner';


@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, DoCheck {
  @Input() state_menu: boolean;
  @Input() fade_box: boolean;
  @Input() url_menu: Array<string>;
  @Output() dash_state = new EventEmitter();

  @Input() idUser : any;

  public status: boolean;
  public role_id: any;
  public user: any;
  public user_id: any;
  public tiendaUser: any = '';
  public bandera : any = false;
  public id_status: any;
  public detalle_status: any;
  public status_list: any = [];
  private subscription: Subscription;


  constructor(
    public _sharedService: SharedService,
    private _router: Router,
    public toastr: ToastsManager,
    public logger: Logger,
    private spinner: NgxSpinnerService
  ) {
    let data = { 
      auth_token: this._sharedService.getCookie("auth_token")
    };

    this.spinner.show();
    this._sharedService.getCurrent(data).subscribe(
      data => {
        if (data.status) { 
          this.user = data.data;
          this.user_id = this.user.id;
          this.role_id = this.user.role_id;
        } else {
          this.logger.log(data.message); // Que no tengo permisos. 
        }
      },
      error => {
        //this.spinner.hide();
        this.logger.log(error);

      }
    );
  }

  ngOnInit() {
    this.subscription = this._sharedService.data$.subscribe((action) => {
      if (action) {
        const { id, detalle } = action;
        this.changeStatusUsers(id, detalle); 
      }
    });
  }

  ngOnDestroy(): void {
    
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
  ngDoCheck() {
    if (this.user_id && this.bandera == false) {
      this.bandera = true;
      let data = {
        auth_token: this._sharedService.getCookie("auth_token"),
        user_id : this.user_id
      };

      this._sharedService.getTienda(data).subscribe(
        response => {
          
          if (response.data.data != '') {
            this.tiendaUser = response.data.data[0].tienda ;
            const videocall = response.data.data[0].videocall; 
            const videocallDuration = response.data.data[0].videocallDuration;
            localStorage.setItem('videocall', videocall.toString()); 
            localStorage.setItem('videocallDuration', videocallDuration ? videocallDuration.toString() : 'null');
            localStorage.setItem('idTienda', response.data.data[0].id.toString());
          }else{
            this.tiendaUser = '';
          }
        },
        error => {
          console.log(<any>error); 
        }
      );

      this._sharedService.getStatusUsers(data).subscribe(
        response => {
          this.detalle_status = response.data.detalle_status;
          this.id_status = response.data.id_status;
          const isVideocallUnload = sessionStorage.getItem("isReloadingVideocall");
          if(isVideocallUnload){
            this.changeStatusUsers(1,"Activo");
          }
        },
        error => {
          console.log(<any>error); 
        }
      );

      this._sharedService.getStatusConetion(data).subscribe(
        data => {
          let valuei= 0;

          for (let i = 0; i < data.data.length; i++) {
            let vClass = '';

            if (data.data[i].id_status == this.id_status) {
              vClass = 'active';
            }
            this.status_list[i] = 
            {'id': data.data[i].id_status, 'itemName':data.data[i].description, 'avaliable':data.data[i].avaliable, 'clase': vClass};
            valuei = i;  
          }
        },
        error => { //server error
          //this.load = false;
          this.spinner.hide();
          this.toastr.error('Ha ocurrido un error, inténtalo de nuevo', 'Error');
          this.logger.log(error);
        }
      );

    }
  }

  changeStatusUsers(id, detalle) {
    let data = {
      auth_token: this._sharedService.getCookie("auth_token"),
      user_id : this.user_id,
      id_status : id,
      detalle : detalle
    };

    this._sharedService.updateStatus(data).subscribe(
      response => {
        this.bandera = false;
      },
      error => {
        console.log(<any>error); 
      }
    );
  }

  onLogout() {
    this.spinner.show();
    this._sharedService.logout().subscribe(
      data => {
        if (data.code_status === 200) {
          this.toastr.success('Has salido del sitio', 'Éxito!');
          this._sharedService.user = null;
          let bot = document.getElementById('live-chat');
          bot.style.display = 'none';
          this.logger.log(this._sharedService.user);
          this._router.navigate(['/auth', {}]);
          this._sharedService.setCookie('auth_token', '', -1, environment.c_domain);
        } else {
          this.toastr.error(data.message, 'Error');
          this.logger.log(data);
        }
        this.spinner.hide();
      },
      error => {
        this.toastr.error('Ocurrió un error, por favor intente de nuevo', 'Error');
        this.logger.log(<any>error);
        this.spinner.hide();
      }
    );
  }




  Menu(state) {
    this.state_menu = state;
    this.fade_box = state;
  }

  Show_dash(value) {
    this.dash_state.emit(value);
    //console.log(value);
  }

  toggleStatus() { 
    // Se cambia el estado del agente. (0: Off, 1: On)
    if (this._sharedService.user.status === 1) {
      this._sharedService.user.status = 0;
      this.status = false;
    } else {
      this._sharedService.user.status = 1;
      this.status = true;
      console.log('Encendido!');
    }

    let data = {
      auth_token: this._sharedService.getCookie('auth_token'),
      status: this.status
    };

    this._sharedService.toggleStatus(data).subscribe(
      response => {
        if (response.code === 200) {
          let status = response.data.status
          console.log('Este es el estatus', status);
          this._sharedService.ChangeStatus(status);
        } else {
          console.log('Este es el estatus',response);
        }
      },
      error => {
        console.log(<any>error); 
      }
    );
    // Acá se cierran todas las conversaciones cuando el agente pasa a off. 
    /*
    if (this.status === false) {

      let data2 = {
        auth_token: this._sharedService.getCookie('auth_token'),
        status_id: 5
      };
      this._sharedService.toggleStatusCloseRooms(data2).subscribe(
        response => {
          console.log('Respuesta del servidor');
          console.log(response);
        }
      );
    }*/
  }

}



// WEBPACK FOOTER //
// /home/ec2-user/PasoAgentes/PA_frontend_routemobile/src/app/shared/header/header.component.ts